<template>
  <!-- 学生出入统计模块边框  -->
  <div class="h-border-box-1" :style="{background:background}">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position1" src="static/img/border/1.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position2" src="static/img/border/2.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position3" src="static/img/border/3.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position4" src="static/img/border/4.png" alt="">
    <div class="h-border-box-1-title" v-if="title">
      <span class="h-border-box-1-title-text">{{title}}</span>
      <!-- <img class="h-border-box-1-title-icon" src="static/img/student/border-box-1-bg2.png" alt=""> -->
      <!-- <div class="h-border-box-1-title-border"></div>
      <div class="h-border-box-1-title-border2"></div> -->
      <img class="h-border-box-1-title-bg" src="static/img/border/titlebg.png" mode="" />
      <div class="birthdayImgSign" v-if="imgStatus">
        <img src="static/img/overview/birtherday.png" alt="">
      </div>
    </div>
    <div class="h-border-box-1-content">
      <slot></slot>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    background: {
      //背景颜色
      type: String,
      default: 'rgba(19, 54, 119, 0.6)',
    },
    title: {
      type: String,
      default: '',
    },
    imgStatus: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>
<style scoped lang="stylus">
.h-border-box-1
  height 100%
  width 100%
  position relative
  display flex
  flex-direction column
  border 2px solid #019BD8
  .h-border-box-1-bg1
    height 80px
    width 80px
    position absolute
  .h-border-box-1-bg1-position1
    top -4px
    left -4px
  .h-border-box-1-bg1-position2
    top -4px
    right -4px
    // transform rotate(90deg)
  .h-border-box-1-bg1-position3
    bottom -4px
    right -6px
    // transform rotate(180deg)
  .h-border-box-1-bg1-position4
    bottom -4px
    left -4px
    // transform rotate(270deg)
  .h-border-box-1-title
    position relative
    display flex
    flex-direction row
    align-items center
    height 80px
    width 100%
    flex-shrink 0
    .h-border-box-1-title-text
      flex 1
      height 80px
      line-height 80px
      font-size 26px
      color rgba(0, 205, 255, 1)
      font-weight bold
      margin-left 30px
      font-family Source Han Sans CN
    .h-border-box-1-title-icon
      margin-right 23px
    .h-border-box-1-title-border
      position absolute
      bottom 0
      height 1px
      width 100%
      background-color rgba(5, 80, 123, 1)
    .h-border-box-1-title-border2
      position absolute
      bottom 0
      left 30px
      height 1px
      width 32px
      background-color #1BCAF2
    .birthdayImgSign
      position absolute
      top 10px
      right 10px
      z-index 999999
  .h-border-box-1-content
    flex 1
    width 100%
  .h-border-box-1-title-bg
    height 52px
    position absolute
    left 15px
</style>



// WEBPACK FOOTER //
// src/components/parts/h-border-box/h-border-box-2.vue